import { render, staticRenderFns } from "./DialogTableFootnote.vue?vue&type=template&id=dc3591ee"
import script from "./DialogTableFootnote.vue?vue&type=script&lang=js"
export * from "./DialogTableFootnote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports